import React, { useState } from "react";
import { IFeedbackQuestion } from "../feedback.type";
import {
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography,
} from "@material-ui/core";
import { feedbackStyle } from "../style";

export const MultipleChoiceFeedbackQuestion: React.FC<IFeedbackQuestion> = (
	props
) => {
	const [disabled, setDisabled] = useState(false);
	const { question } = props;
	const classes = feedbackStyle();

	if (!question || question.type !== "multiple_choice") {
		return null;
	}

	const containerClasses = [
		classes.scaleContainer,
		classes.radioContainer,
		disabled ? classes.disabled : "",
	];

	const handleChange = (value: string) => {
		if (props.onChange) {
			props.onChange(question.id, value);
		}
		setDisabled(true);
		setTimeout(() => {
			setDisabled(false);
		}, 800);
	};

	return (
		<div className={containerClasses.join(" ")}>
			<RadioGroup>
				{question.config.options.map((option, index) => {
					return (
						<FormControlLabel
							key={`${question.commonId}-${index}`}
							value={option.value}
							control={<Radio className={classes.radio} />}
							label={
								<Typography variant="body2">
									{option.label}
								</Typography>
							}
							onChange={() => handleChange(option.value)}
						/>
					);
				})}
			</RadioGroup>
		</div>
	);
};
